var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
import "./app.scss";
import { TreeVisibility, } from "./core/treeModel";
import { TreeReact } from "./tree";
var randomNumbers = function (from, to, count) {
    var result = new Set();
    var range = to - from + 1;
    while (result.size !== count) {
        var index = Math.floor(Math.random() * range);
        if (!result.has(index)) {
            result.add(index);
        }
    }
    return Array.from(result);
};
var createData = function () {
    var _a, _b;
    var tickers = ["F", "AMZN", "NFLX", "GOOG", "APPL"];
    var contracts = [
        "JAN",
        "FEB",
        "MAR",
        "APR",
        "MAY",
        "JUN",
        "JUL",
        "AUG",
        "SEP",
        "OCT",
        "NOV",
        "DEC",
    ];
    var prices = 5;
    var data = [];
    for (var i = 0; i < tickers.length; i++) {
        // const includeTicker = !!Math.floor(Math.random() * 2);
        // if (!includeTicker) {
        //   break;
        // }
        var ticker = tickers[i];
        var dataNodes = {
            element: { id: ticker, text: ticker },
            children: [],
        };
        data.push(dataNodes);
        for (var i_1 = 0; i_1 < contracts.length; i_1++) {
            // const includeContract = !!Math.floor(Math.random() * 2);
            // if (!includeContract) {
            //   break;
            // }
            var contract = contracts[i_1];
            var contractNode = {
                element: { id: ticker + "/" + contract, text: contract },
                children: [],
            };
            (_a = dataNodes.children) === null || _a === void 0 ? void 0 : _a.push(contractNode);
            for (var i_2 = 0; i_2 < prices; i_2++) {
                // const includePrice = !!Math.floor(Math.random() * 2);
                // if (!includePrice) {
                //   break;
                // }
                (_b = contractNode.children) === null || _b === void 0 ? void 0 : _b.push({
                    element: {
                        id: ticker + "/" + contract + "/" + i_2,
                        text: Number("" + (Math.random() *
                            100 *
                            (Math.floor(Math.random() * 2) ? 1 : -1)).toFixed(2)),
                    },
                    height: 15,
                });
            }
        }
    }
    return data;
};
var Template = function (props) {
    var _a, _b;
    var list = props.tree.list;
    var model = props.tree.model;
    var node = props.node;
    var onClick = function () {
        model.setCollapsed(node, !node.collapsed);
    };
    if (!node) {
        return React.createElement("div", null);
    }
    var text = (_a = node === null || node === void 0 ? void 0 : node.element) === null || _a === void 0 ? void 0 : _a.text;
    var color = typeof text === "number"
        ? text > 0
            ? "rgb(2, 192, 118)"
            : text < 0
                ? "rgb(248, 73, 96)"
                : ""
        : "";
    return (React.createElement("div", { onClick: props.selectRow, style: {
            display: "flex",
            alignItems: "center",
            height: "100%",
            backgroundColor: props.isSelected ? "rgba(30,144,255,0.3)" : "",
        } },
        React.createElement("span", { style: { marginLeft: node.depth * 16 + "px" } }),
        React.createElement("span", { style: {
                display: "flex",
                flexGrow: 1,
                height: "100%",
                alignItems: "center",
            } },
            node.collapsible && (React.createElement("span", { style: { userSelect: "none", cursor: "pointer" }, onClick: onClick },
                React.createElement("a", { style: { outline: "none" }, className: "material-icons" }, node.collapsed ? "chevron_right" : "expand_more"))),
            React.createElement("span", { style: { color: color } }, (_b = node === null || node === void 0 ? void 0 : node.element) === null || _b === void 0 ? void 0 : _b.text))));
};
export var App = function () {
    var ref = React.useRef();
    var _a = __read(React.useState({ filter: undefined }), 2), options = _a[0], setOptions = _a[1];
    var _b = __read(React.useState(createData()), 2), data = _b[0], setData = _b[1];
    var _c = __read(React.useState(true), 2), treeMatches = _c[0], setTreeMatches = _c[1];
    var _d = __read(React.useState(""), 2), inputValue = _d[0], setInputValue = _d[1];
    var internalSubscription = React.useRef();
    var _e = __read(React.useState(), 2), subscription = _e[0], setSubscription = _e[1];
    var onChange = function (event) {
        return setInputValue(event.target.value.toLowerCase());
    };
    var onSelectedChanged = function (value) {
        console.log("selected", value);
    };
    var onReady = function (event) {
        ref.current = event.api;
    };
    var identityProvider = React.useMemo(function () { return ({
        getId: function (element) {
            var _a;
            return (_a = element.id) === null || _a === void 0 ? void 0 : _a.toString();
        },
    }); }, []);
    React.useEffect(function () {
        if (!subscription) {
            clearInterval(internalSubscription.current);
            internalSubscription.current = undefined;
            return;
        }
        internalSubscription.current = setInterval(function () {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setChildren(createData());
        }, 1000);
    }, [subscription]);
    React.useEffect(function () {
        setOptions({
            filter: function (element) {
                var _a;
                if ((_a = element === null || element === void 0 ? void 0 : element.text) === null || _a === void 0 ? void 0 : _a.toString().toLowerCase().includes(inputValue)) {
                    // return TreeVisibility.Visible;
                    return treeMatches ? TreeVisibility.Tree : TreeVisibility.Visible;
                }
                return TreeVisibility.Recurse;
            },
        });
    }, [treeMatches, inputValue]);
    var toggleKeyboard = function (f) { return function (ev) { return ev.key === "Enter" && f(function (_) { return !_; }); }; };
    var toggle = function (f) { return function () {
        return f(function (_) { return !_; });
    }; };
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "tree-container" },
            React.createElement("div", { className: "settings-container" },
                React.createElement("div", null,
                    React.createElement("span", null, "Tree matches"),
                    React.createElement("input", { type: "checkbox", checked: treeMatches, onChange: toggle(setTreeMatches), onKeyDown: toggleKeyboard(setTreeMatches) })),
                React.createElement("div", null,
                    React.createElement("span", null, "Stream data"),
                    React.createElement("input", { type: "checkbox", checked: subscription, onChange: toggle(setSubscription), onKeyDown: toggleKeyboard(setSubscription) })),
                React.createElement("input", { value: inputValue, style: { width: "100%" }, type: "text", onChange: onChange, placeholder: "Search" })),
            React.createElement(TreeReact, { className: "demo-tree", onReady: onReady, template: Template, onSelectionChanged: onSelectedChanged, data: data, filter: options.filter, identityProvider: identityProvider }))));
};
